import React from 'react';
import { motion } from 'framer-motion';
import './Home.css';
import { WHATSAPP_AULA } from '../config';

const Home = () => {
  return (
    <section id="home" className="s_title">
      <motion.div
        className="content"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
      >
        <span className="hero-tag">+20 anos de experiência</span>
        <h1 className="h1_title">Junta-te a nós!</h1>
        <p className="p_title">
          A Escola de Kickboxing Hugo Matos tem mais de 20 anos de experiência a formar campeões e a inspirar pessoas para a vida.
        </p>
        <a className="btn-primary" href={WHATSAPP_AULA} target="_blank" rel="noopener noreferrer">
          Marca já a tua aula
        </a>
      </motion.div>

      <a href="#about" className="scroll-indicator" aria-label="Ir para a secção Sobre">
        <span className="scroll-arrow" aria-hidden="true"></span>
      </a>
    </section>
  );
};

export default Home;
